import { FC } from 'react';
import { connect } from 'react-redux';

import { toggleSelectTableColumn } from '../_actions';
import { getColumns, getShouldPreventEditing } from '../_selectors';
import { columnToChars } from '../_utils';

interface IHead {
  columns: number[];
  toggleSelectTableColumn: (column: number) => void;
  shouldPreventEditing: boolean;
}

const Head: FC<IHead> = ({ columns, toggleSelectTableColumn, shouldPreventEditing }) => {
  const baseClassName = shouldPreventEditing ? 'ordering_form__table__prevent_editing_cell' : '';

  return (
    <thead>
      <tr>
        <th style={{ width: '40px' }} className="!border-none !bg-transparent"></th>
        {columns.map((column) => {
          const columnChar = columnToChars(column);

          return (
            <th
              key={`cell-${columnChar}-0`}
              id={`cell-${columnChar}-0`}
              className={
                column === 0
                  ? `${baseClassName} ordering_form__table__disabled_cell`
                  : baseClassName
              }
              onClick={() => (shouldPreventEditing ? null : toggleSelectTableColumn(column))}
            >
              {columnChar}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default connect(
  (state) => ({
    columns: getColumns(state),
    shouldPreventEditing: getShouldPreventEditing(state)
  }),
  { toggleSelectTableColumn }
)(Head);
